import React from 'react';
import '../../styles/global.scss';
import SiteContainer from './SiteContainter';
import ProfilePanel from '../ProfilePanel';
import SiteContent from './SiteContent';
import Header from '../Header';
var Layout = function Layout(_ref) { var children = _ref.children; return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Header, null), /*#__PURE__*/ React.createElement(SiteContainer, null, /*#__PURE__*/ React.createElement(ProfilePanel, null), /*#__PURE__*/ React.createElement(SiteContent, null, children))); };
export default Layout;
